import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertred = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 48,
	viewBox: "0 0 50 48",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M42.1875 47.4344H7.8125C3.50469 47.4344 0 43.9297 0 39.6219C0 38.2851 0.343945 36.9653 0.994922 35.8047L18.1782 4.56211C18.1813 4.55664 18.1843 4.55127 18.1873 4.5458C21.1718 -0.760159 28.827 -0.762112 31.8128 4.5458C31.8158 4.55117 31.8188 4.55664 31.8219 4.56211L49.0053 35.8046C49.6561 36.9652 50 38.285 50 39.6219C50 43.9297 46.4953 47.4344 42.1875 47.4344ZM21.5961 6.45351L4.41348 37.6946C4.41045 37.7001 4.40742 37.7056 4.40439 37.7109C4.07852 38.2902 3.90625 38.9511 3.90625 39.6219C3.90625 41.7758 5.65859 43.5281 7.8125 43.5281H42.1875C44.3414 43.5281 46.0938 41.7758 46.0938 39.6219C46.0938 38.951 45.9215 38.2902 45.5956 37.7109C45.5926 37.7056 45.5896 37.7001 45.5865 37.6946L28.4042 6.454C26.9091 3.80869 23.093 3.80566 21.5961 6.45351Z",
			fill: "#E04953"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 29.8562C23.9213 29.8562 23.0469 28.9818 23.0469 27.9031V16.1844C23.0469 15.1057 23.9213 14.2312 25 14.2312C26.0787 14.2312 26.9531 15.1057 26.9531 16.1844V27.9031C26.9531 28.9818 26.0787 29.8562 25 29.8562Z",
			fill: "#E04953"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 37.6687C26.0787 37.6687 26.9531 36.7943 26.9531 35.7156C26.9531 34.6369 26.0787 33.7625 25 33.7625C23.9213 33.7625 23.0469 34.6369 23.0469 35.7156C23.0469 36.7943 23.9213 37.6687 25 37.6687Z",
			fill: "#E04953"
		})
	]
});
const ForwardRef = forwardRef(SvgAlertred);
export default ForwardRef;
